module.exports = __webpack_public_path__ + "static/media/success.85e4b1e1.svg";